import * as React from "react";
import { connect } from "react-redux";
import { AnyAction } from "redux";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import {} from "@amzn/arb-tools";
import styled from "styled-components";
import * as rootStyles from "../../styles";
import { BundleMap } from "../../../models";
import { RootState, userActions } from "../../../store";
import { stringIds, bundleIds } from "../../../assets";
import {
    getLocalizedString,
    getLocalizedTerms,
    LARGE_SCREEN_WIDTH_THRESHOLD,
    paths,
} from "../../../utils";
import {
    CommonHeader,
    StickyDismissFooter,
    DISMISS_FOOTER_HEIGHT,
} from "../../components";
import "../../styles/termsAndConditions.css";
import { bundleMapSelector } from "../../../store/selectors/commonSelectors";

export const termsAndConditionsIdPrefix = "TermsAndConditions";
const testIDPrefix = "TermsAndConditionsScreen";
const metricPrefix = "TermsAndConditionsPage";

type ViewProps = {};

type StateProps = {
    bundleMap: BundleMap;
};

type DispatchProps = {
    updateCurrentPath: (payload: string) => void;
};

type Props = DispatchProps & StateProps & RouteComponentProps<ViewProps>;

export class TermsAndConditionsScreen extends React.Component<Props> {
    constructor(props: any) {
        super(props);
        this.state = {};
        this.props.updateCurrentPath(window.location.pathname);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    componentDidUpdate(prevProps: Props) {}

    render() {
        return (
            <Container
                id={termsAndConditionsIdPrefix + "-Container"}
                fluid={true}
                className="rootContainer"
                style={rootStyles.containerStyles.rootViewContainer}
            >
                <CommonHeader
                    title={getLocalizedString(this.props.bundleMap, {
                        bundleId: bundleIds.SETTINGS_STRINGS,
                        stringId: stringIds.Settings.tocLabel,
                    })}
                    id={`${testIDPrefix}_Header`}
                    hideArtistImgDropdown={true}
                    hideDatePicker={true}
                />
                <ContentRow
                    id={termsAndConditionsIdPrefix + "-Content"}
                >
                    <Col>{getLocalizedTerms()}</Col>
                </ContentRow>
                <StickyDismissFooter
                    title={getLocalizedString(this.props.bundleMap, {
                        bundleId: bundleIds.GENERIC_STRINGS,
                        stringId: stringIds.Generic.dismiss,
                    })}
                    onClick={() => this.props.history.goBack()}
                    id={`${testIDPrefix}_DismissButton`}
                />
            </Container>
        );
    }
}

const ContentRow = styled(Row)`
    margin-bottom: ${rootStyles.spacers.medium}px;
    @media (max-width: ${LARGE_SCREEN_WIDTH_THRESHOLD}px) {
        margin-bottom: ${DISMISS_FOOTER_HEIGHT + rootStyles.spacers.medium}px;
    }
`;

function mapStateToProps(state: RootState): StateProps {
    return bundleMapSelector(state);
}

function mapDispatchToProps(dispatch: React.Dispatch<AnyAction>) {
    return {
        updateCurrentPath: (payload: string) =>
            dispatch(userActions.updateCurrentPath(payload)),
    };
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(TermsAndConditionsScreen)
);
